import { render, staticRenderFns } from "./workOrderType.vue?vue&type=template&id=23c2793b&scoped=true&"
import script from "./workOrderType.vue?vue&type=script&lang=js&"
export * from "./workOrderType.vue?vue&type=script&lang=js&"
import style0 from "./workOrderType.vue?vue&type=style&index=0&id=23c2793b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c2793b",
  null
  
)

export default component.exports